import { render, staticRenderFns } from "./FullScreenFile.vue?vue&type=template&id=53b00f85&scoped=true&"
import script from "./FullScreenFile.vue?vue&type=script&lang=js&"
export * from "./FullScreenFile.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenFile.vue?vue&type=style&index=0&id=53b00f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b00f85",
  null
  
)

export default component.exports